import * as styles from "./PdfViewerDialog.css";

import { type JSX, useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@frontend/components/atoms/Dialog";

import { PdfViewer } from "./PdfViewer";
import type { PdfViewerDialogProps } from "./PdfViewer.types";
import { documentNameFrom } from "./documentName";

export function PdfViewerDialog({
  children,
  open: openProp,
  defaultOpen = false,
  onOpenChange,
  src,
  name,
  ...options
}: PdfViewerDialogProps): JSX.Element {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);

  const open = openProp ?? uncontrolledOpen;

  const documentName = name ?? documentNameFrom(src);

  const handleOpenChange = (next: boolean) => {
    setUncontrolledOpen(next);
    onOpenChange?.(next);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      {children === undefined ? null : (
        <DialogTrigger
          render={<div style={{ display: "contents" }} />}
          nativeButton={false}
        >
          {children}
        </DialogTrigger>
      )}

      <DialogContent
        fullscreen
        // The viewer's own toolbar carries the close button, so the dialog
        // needs no header, and its name has to come from here instead.
        aria-label={documentName}
        className={styles.content}
      >
        {/* Mounted with the dialog, so the engine and its worker start when the
            document is opened and are torn down when it closes. */}
        {open ? (
          <PdfViewer
            {...options}
            src={src}
            name={documentName}
            height="100%"
            className={styles.viewer}
            onClose={() => handleOpenChange(false)}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
